import { TvLocationScreen, TvResponse, TvScreen } from 'entities/TvRender/interfaces';
import {
  CHANGE_TV_SCREEN,
  GET_TV_DATA_ERROR,
  GET_TV_DATA_REQUEST,
  GET_TV_DATA_SUCCESS,
  RESET_TV_SCREEN,
} from './constants';

export const changeScreen = (screen: TvScreen | null) => ({
  type: CHANGE_TV_SCREEN,
  payload: screen,
});

export const getTvDataRequest = () => ({
  type: GET_TV_DATA_REQUEST,
});

export const resetScreen = () => ({
  type: RESET_TV_SCREEN,
});

export const getTvDataSuccess = (
  data: TvResponse,
  screens: TvScreen[],
  currentScreen: TvScreen | null,
  pauseData: TvLocationScreen | null,
) => ({
  type: GET_TV_DATA_SUCCESS,
  payload: data,
  screens,
  currentScreen,
  pauseData,
});

export const getTvDataError = (error: Error | null) => ({
  type: GET_TV_DATA_ERROR,
  payload: error,
});

export type Actions =
  | ReturnType<typeof changeScreen>
  | ReturnType<typeof getTvDataRequest>
  | ReturnType<typeof getTvDataSuccess>
  | ReturnType<typeof getTvDataError>
  | ReturnType<typeof resetScreen>;
